/** @format */

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MessageTemplate from "../dao/MessageTemplate";
import swal from "../reusables/CustomSwal";
import { timeout } from "../utils/utilitys";
import PhoneNumber from "../dao/PhoneNumber";

export default function ConfirmationDialog(props) {
  const { open, onClose, createData, sendData } = props;
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const handleClose = (newData) => {
    onClose();
  };

  const handleSendBroadcast = async () => {
    try {
      setLoading((x) => !x);
      let key = await PhoneNumber.getToken({
        number: createData.phone_number,
      });
      createData["partner_token"] = await key?.token;
      let response = await MessageTemplate.createBroadcast(createData);
      sendData["broadcast_id"] = await response.id;
      let data = await MessageTemplate.sendBroadcast(sendData);
      if (data?.statusCode === 400) {
        await swal.fire({
          title: "Error",
          text: data?.message,
          icon: "error",
        });
      } else {
        await swal.fire({
          title: "Success",
          text: "Broadcast success.",
          icon: "success",
        });
      }

      await timeout(1000);
      await navigate(-1);
      await handleClose(true);
    } catch (e) {
      setLoading((x) => !x);
      await swal.fire({
        title: "Error",
        text: "An error has occurred. Please try again later.",
        icon: "error",
      });
    }
  };

  return (
    <Dialog maxWidth={"sm"} open={open} onClose={() => handleClose(false)}>
      <DialogTitle style={{ color: "grey" }}>
        Are you sure you want to Broadcast WhatsApp?
      </DialogTitle>
      <DialogContent style={{ color: "grey" }}>
        If you press the <b>Yes</b> button, you will send a message to WhatsApp
        users according to the data you uploaded
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleClose();
          }}
          disabled={isLoading}
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            handleSendBroadcast();
          }}
          disabled={isLoading}
        >
          Yes, Sent Messages
        </Button>
      </DialogActions>
    </Dialog>
  );
}
